"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 7,
  fill: "var(--sds--ursa-icons--background-color, var(--smar--com--color--red--75,#fbc6c9))"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.349 12.24c-.211-.114-.352-.273-.4-.502a.697.697 0 0 1 .664-.845 47 47 0 0 1 1.507 0 .69.69 0 0 1 .677.695c.003.479 0 .958 0 1.437 0 .367-.216.641-.56.716-.33.071-.643-.096-.791-.424l-.038-.094-.16.11c-2.192 1.487-5.228.455-6.054-2.059-.134-.41.044-.792.43-.925.38-.13.76.074.9.481a2.607 2.607 0 0 0 3.706 1.479c.037-.02.071-.042.118-.07M8.654 7.778c.233.142.384.32.408.583a.694.694 0 0 1-.683.768q-.747.006-1.493 0a.686.686 0 0 1-.681-.688q-.005-.74 0-1.479a.697.697 0 0 1 1.33-.3c.02.04.037.081.047.102.326-.165.638-.353.971-.486 2.124-.844 4.554.306 5.258 2.48.128.395-.057.789-.432.917-.373.127-.756-.07-.897-.467-.328-.92-.961-1.51-1.912-1.737-.667-.16-1.3-.042-1.915.307z"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ApprovalStatusError20.js.map